import PropTypes from 'prop-types';

import { ReactComponent as DangerIcon } from './assets/DangerIcon.svg';
import { ReactComponent as LowBatteryIcon } from './assets/LowBatteryIcon.svg';
import { ReactComponent as NoWifiIcon } from './assets/NoWifiIcon.svg';
import style from './style.module.css';

const icons = {
  BATTERY: LowBatteryIcon,
  WIFI: NoWifiIcon,
  DANGER: DangerIcon,
};

const WarningWindow = ({ icon = '', title = '', text = '' }) => {
  const Icon = icons[icon];

  return (
    <div className={style.root}>
      {Icon && <Icon />}
      <h1>{title}</h1>
      <p>{text}</p>
    </div>
  );
};

WarningWindow.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

export default WarningWindow;
